type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const LaundryIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <rect x="3" y="2" width="18" height="20" rx="2" />
    <circle cx="12" cy="14" r="5" />
    <circle cx="12" cy="14" r="2" />
    <circle cx="7" cy="5.5" r="1" fill={color} stroke="none" />
  </svg>
);
